import EventDetailsModal from "./EventDetailsModal";
export default EventDetailsModal;
